import { useEffect, useState } from 'react';
import { getMyInvites, acceptInvite, declineInvite } from '../../../../services/applicationService';
import { formatDatePtBr } from '../../../../utils/dateUtils';
import EmptyState from '../../../../Components/EmptyState/EmptyState';
import './InviteJobs.scss';

function formatTime(t) {
  return t ? t.slice(0, 5) : '';
}

export default function InvitedJobs({onInviteHandled}) {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const fetchInvites = async () => {
    try {
      setLoading(true);
      const data = await getMyInvites();
      setInvites(data);
    } catch (err) {
      console.error('Erro ao carregar convites:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchInvites(); }, []);

  const handleAccept = async (applicationId) => {
    setBusyId(applicationId);
    try {
      await acceptInvite(applicationId);
      setInvites(prev => prev.filter(inv => inv.id !== applicationId));
    } catch (err) {
      const msg = err?.response?.data || 'Erro ao aceitar convite.';
      alert(msg);
    } finally {
      setBusyId(null);
    }
  };

  const handleDecline = async (applicationId) => {
    if (!confirm('Recusar este convite?')) return;

    setBusyId(applicationId);
    try {
      await declineInvite(applicationId);
      setInvites(prev => prev.filter(inv => inv.id !== applicationId));
    } catch (err) {
      const msg = err?.response?.data || 'Erro ao recusar convite.';
      alert(msg);
    } finally {
      setBusyId(null);
    }
  };

  if (loading) {
    return <div className="inv-loading">Carregando convites...</div>;
  }

  if (invites.length === 0) {
    return <EmptyState message="Você não tem nenhum convite pendente no momento." />;
  }

  return (
    <section className="inv-wrapper">
      <div className="inv-grid">
        {invites.map(({ id, job }) => (
          <div key={id} className="inv-card">
            <div className="inv-header">
              {job.companyAvatar ? (
                <img src={job.companyAvatar} alt={job.companyName} className="inv-avatar" />
              ) : (
                <div className="inv-avatar-fallback">
                  {job.companyName?.slice(0, 2).toUpperCase()}
                </div>
              )}
              <div>
                <p className="inv-company">{job.companyName}</p>
                <p className="inv-title">{job.title}</p>
              </div>
            </div>

            <div className="inv-badge">✉️ Convite Direto</div>

            <div className="inv-meta">
              <span className="inv-meta-item">📅 {formatDatePtBr(job.date)}</span>
              <span className="inv-meta-item">🕐 {formatTime(job.startTime)} – {formatTime(job.endTime)}</span>
              <span className="inv-meta-item">📍 {job.location}</span>
            </div>

            {job.description && <p className="inv-description">{job.description}</p>}

            <div className="inv-tags">
              {job.dressCode && <span className="inv-tag">👔 {job.dressCode}</span>}
              {job.breakTime && <span className="inv-tag">☕ Intervalo: {job.breakTime} min</span>}
              {job.contactPerson && <span className="inv-tag">👤 {job.contactPerson}</span>}
            </div>

            <div className="inv-footer">
              <span className="inv-payment">
                R$ {Number(job.payment).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
              </span>

              <div className="inv-actions">
                <button
                  className="inv-btn inv-btn--decline"
                  onClick={() => handleDecline(id)}
                  disabled={busyId === id}
                >
                  Recusar
                </button>
                <button
                  className="inv-btn inv-btn--accept"
                  onClick={() => handleAccept(id)}
                  disabled={busyId === id}
                >
                  {busyId === id ? '...' : 'Aceitar'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}